import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { IReasonCode } from 'src/common/interfaces/dtos/IReasonCode';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export const returnReasonCodeLookup = async (
  returnReasonCodeLookupDto: IReturnReasonCodeLookup,
): Promise<IReasonCode[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/returns/policy/reason-code`,
    method: 'GET',
    params: returnReasonCodeLookupDto,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };

  return emeraldRequest<IReasonCode[]>(emeraldRequestParams);
};

export interface IReturnReasonCodeLookup {
  returnPolicyId: number;
  itemId?: string;
  departmentId?: string;
}
